import React, { useState, useRef } from "react";
import { Flex, Table, Tag, Button, Space, Modal } from "antd";
import * as XLSX from "xlsx";
import songolt from "./songolt.json";
import cert from "../../images/certificate_bg.jpg";

const unique = (array, key) => [...new Set(array.map((item) => item[key]))];

const formatDateToMongolian = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = ("0" + (date.getMonth() + 1)).slice(-2);
  const day = ("0" + date.getDate()).slice(-2);
  return `${year} оны ${month} дугаар сарын ${day}`;
};

const AdminSongoltPage = () => {
  const [filteredInfo, setFilteredInfo] = useState({});
  const [filteredData, setFilteredData] = useState(songolt);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const certificateRef = useRef();

  const handleChange = (_, filters, __, extra) => {
    setFilteredInfo(filters);
    setFilteredData(extra.currentDataSource);
  };

  const exportToExcel = (data, filename) => {
    const formatted = data.map((row) => ({
      Огноо: row.created_at,
      Сургууль: row.school,
      Овог: row.first_name,
      Нэр: row.last_name,
      Имэйл: row.email,
      Утас: row.contact_number,
      Анги: row.school_class,
      "Үндсэн мэргэжил": row.main_profession,
      "Дэд мэргэжил": row.sub_profession,
    }));

    const worksheet = XLSX.utils.json_to_sheet(formatted);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Сонголт");
    XLSX.writeFile(workbook, `${filename}.xlsx`);
  };

  const showCertificateModal = (record) => {
    setSelectedRecord(record);
    setIsModalOpen(true);
  };

  const columns = [
    {
      title: "Огноо",
      dataIndex: "created_at",
      key: "created_at",
      render: (created_at) => <Tag color="blue">{created_at}</Tag>,
    },
    {
      title: "Сургууль",
      dataIndex: "school",
      key: "school",
      filteredValue: filteredInfo.school || null,
      onFilter: (value, record) => record.school.includes(value),
      filters: unique(songolt, "school").map((val) => ({
        text: val,
        value: val,
      })),
      filterSearch: true,
    },
    {
      title: "Овог",
      dataIndex: "first_name",
      key: "first_name",
      filteredValue: filteredInfo.first_name || null,
      onFilter: (value, record) => record.first_name.includes(value),
      filters: unique(songolt, "first_name").map((val) => ({
        text: val,
        value: val,
      })),
      filterSearch: true,
    },
    {
      title: "Нэр",
      dataIndex: "last_name",
      key: "last_name",
      filteredValue: filteredInfo.last_name || null,
      onFilter: (value, record) => record.last_name.includes(value),
      filters: unique(songolt, "last_name").map((val) => ({
        text: val,
        value: val,
      })),
      filterSearch: true,
    },
    {
      title: "Имэйл",
      dataIndex: "email",
      key: "email",
      render: (email) => <Tag color="green">{email}</Tag>,
    },
    // {
    //   title: "Утас",
    //   dataIndex: "contact_number",
    //   key: "contact_number",
    // },
    {
      title: "Анги",
      dataIndex: "school_class",
      key: "school_class",
      filteredValue: filteredInfo.school_class || null,
      onFilter: (value, record) => record.school_class === value,
      filters: unique(songolt, "school_class").map((val) => ({
        text: val,
        value: val,
      })),
      filterSearch: true,
    },
    {
      title: "Үндсэн мэргэжил",
      dataIndex: "main_profession",
      key: "main_profession",
      filteredValue: filteredInfo.main_profession || null,
      onFilter: (value, record) => record.main_profession === value,
      filters: unique(songolt, "main_profession").map((val) => ({
        text: val,
        value: val,
      })),
      filterSearch: true,
    },
    {
      title: "Дэд мэргэжил",
      dataIndex: "sub_profession",
      key: "sub_profession",
      filteredValue: filteredInfo.sub_profession || null,
      onFilter: (value, record) => record.sub_profession === value,
      filters: unique(songolt, "sub_profession").map((val) => ({
        text: val,
        value: val,
      })),
      filterSearch: true,
    },
    {
      title: "Үйлдэл",
      key: "action",
      render: (_, record) => (
        <Button type="link" onClick={() => showCertificateModal(record)}>
          Батламж
        </Button>
      ),
    },
  ];

  return (
    <Flex style={{ width: "100%" }} vertical align="center">
      <div
        style={{
          width: "100%",
          padding: "0 20px",
          marginBottom: "10px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div>
          Нийт: <b>{filteredData.length}</b>
        </div>
        <Space>
          <Button
            type="primary"
            onClick={() => exportToExcel(filteredData, "songolt_filtered")}
          >
            Жагсаалт татаж авах
          </Button>
        </Space>
      </div>

      <Table
        columns={columns}
        dataSource={songolt}
        rowKey={(record) => record.email}
        pagination={{ pageSize: 10 }}
        onChange={handleChange}
        components={{
          body: {
            cell: (props) => (
              <td {...props} style={{ fontSize: 12 }}>
                {props.children}
              </td>
            ),
          },
        }}
      />

      <Modal
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        width={900}
        style={{ top: 20 }}
      >
        {selectedRecord && (
          <div
            id="certificate"
            ref={certificateRef}
            style={{
              width: "210mm",
              height: "297mm",
              padding: "250px 150px 150px 150px",
              margin: "0 auto",
              boxSizing: "border-box",
              position: "relative",
              userSelect: "none",
              backgroundImage: `url(${cert})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          >
            <h1
              style={{
                color: "#3a6dcc",
                fontWeight: "bold",
                fontSize: "48px",
                textAlign: "center",
                textShadow: "2px 2px 0 #e81c7a",
                marginBottom: "10px",
                letterSpacing: "1.5px",
              }}
            >
              БАТЛАМЖ
            </h1>
            <p
              style={{
                textAlign: "center",
                marginTop: 0,
                marginBottom: 40,
                fontWeight: "bold",
                fontSize: 18,
              }}
            >
              ЭРХЭМ
            </p>

            <p
              style={{
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "24px",
                color: "#001f4d",
                margin: 0,
              }}
            >
              {selectedRecord.first_name?.toUpperCase() || ""} овогтой{" "}
              {selectedRecord.last_name?.toUpperCase() || ""}
            </p>

            <p
              style={{
                textAlign: "center",
                fontSize: "16px",
                margin: "20px 0",
              }}
            >
              ТАНД
              <br />
              2024-2025 оны хичээлийн жилд Монгол-Германы хамтарсан <br />
              <b>“Ажил мэргэжлийн чиг баримжаа олгох”</b> загвар төслийн <br />
              үйл ажиллагаанд амжилттай хамрагдсан тул энэхүү <br />
              <b>БАТЛАМЖ</b>-ийг олгов.
            </p>

            <div
              style={{
                marginTop: 60,
                fontSize: 16,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div>
                Мэргэжлийн чиглэл: <b>{selectedRecord.main_profession} </b>
                <br />
                Мэргэжил: <b>{selectedRecord.sub_profession}</b>
              </div>
            </div>
            <div style={{ marginTop: 10, textAlign: "center" }}>
              {formatDateToMongolian(selectedRecord.created_at)}
            </div>
            <div
              style={{
                marginTop: 80,
                display: "flex",
                justifyContent: "space-between",
                fontWeight: "bold",
                fontSize: 14,
                borderTop: "1px solid #dedede",
                paddingTop: 10,
              }}
            >
              <div style={{ width: "45%", textAlign: "center" }}>
                <b>Т.НЯМ-ОЧИР</b>
                <br />
                <p style={{ fontSize: "12px", margin: 0 }}>
                  Төслийн хэрэгжүүлэгч байгууллага
                  <br />
                  БОЛОВСРОЛЫН ЕРӨНХИЙ ГАЗАР
                </p>
              </div>
              <div style={{ width: "45%", textAlign: "center" }}>
                <b>С.ГАНТӨР</b>
                <br />
                <p style={{ fontSize: "12px", margin: 0 }}>
                  “ХӨГЖИЛ” Мэргэжлийн чиг баримжаа, боловсрол олгох төв
                </p>
              </div>
            </div>
          </div>
        )}
      </Modal>
    </Flex>
  );
};

export default AdminSongoltPage;
